<template>
  <section id="paul">
    <div ref="container" class="three-container"></div> <!-- 用于渲染3D场景的容器 -->
  </section>
</template>

<script>
export default {
  name: 'PaulSection',
  mounted() {
    this.init3DScene();
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeUnmount() {
    if (this.scene) {
      this.scene.dispose();
    }
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    init3DScene() {
      // 创建3D场景
      this.scene = new window.THREE.Scene();

      // 创建相机
      this.camera = new window.THREE.PerspectiveCamera(
        75, // 视场角度
        window.innerWidth / window.innerHeight, // 宽高比
        0.1, // 近裁剪面
        1000 // 远裁剪面
      );

      // 创建渲染器
      this.renderer = new window.THREE.WebGLRenderer();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      this.$refs.container.appendChild(this.renderer.domElement); // 将渲染器添加到容器中

      // 加载纹理
      this.loadTextures();

      // 创建地球球体
      const earthGeometry = new window.THREE.SphereGeometry(5.5, 60, 60); // 地球大小 5.5
      const earthMaterial = new window.THREE.MeshStandardMaterial({
        map: this.earthTexture,
        emissive: new window.THREE.Color(0xffff00),
        emissiveMap: this.earthTexture,
        emissiveIntensity: 0.01,
      });
      this.earth = new window.THREE.Mesh(earthGeometry, earthMaterial);
      this.scene.add(this.earth);

      // 创建地球的月亮
      this.moons = this.createMoons();
      this.moons.forEach(moon => this.scene.add(moon));

      // 添加太阳光照
      this.addLighting();

      // 设置相机位置
      this.camera.position.z = 15;

      // 启动动画
      this.animate();
    },

    loadTextures() {
      // 加载地球和月亮的纹理
      this.earthTexture = new window.THREE.TextureLoader().load(require('@/assets/textures/2k_earth_nightmap.png'));
      this.moonTexture = new window.THREE.TextureLoader().load(require('@/assets/textures/2k_moon.jpg'));

      // 设置纹理的过滤方式
      this.earthTexture.minFilter = window.THREE.NearestFilter;
      this.earthTexture.magFilter = window.THREE.NearestFilter;
      this.earthTexture.wrapS = window.THREE.RepeatWrapping;
      this.earthTexture.wrapT = window.THREE.RepeatWrapping;

      this.moonTexture.minFilter = window.THREE.LinearFilter;
      this.moonTexture.magFilter = window.THREE.LinearFilter;
      this.moonTexture.wrapS = window.THREE.RepeatWrapping;
      this.moonTexture.wrapT = window.THREE.RepeatWrapping;
    },

    createMoons() {
      const moons = [];
      const moonGeometry = new window.THREE.SphereGeometry(0.2, 32, 32);
      const moonMaterial = new window.THREE.MeshStandardMaterial({ map: this.moonTexture });
      const moonOrbitRadius = 10;

      for (let i = 0; i < 4; i++) {
        const moon = new window.THREE.Mesh(moonGeometry, moonMaterial);
        moon.position.set(moonOrbitRadius * Math.cos(i * Math.PI / 2), 0, moonOrbitRadius * Math.sin(i * Math.PI / 2));
        moons.push(moon);
      }

      return moons;
    },

    addLighting() {
      // 太阳光照
      const directionalLight = new window.THREE.DirectionalLight(0xffffff, 2.8);
      directionalLight.position.set(0.5, -0.7, 0).normalize();
      this.scene.add(directionalLight);

      const directionalLight1 = new window.THREE.DirectionalLight(0x0000ff, 0.3);
      directionalLight1.position.set(-0.5, -0.8, 0).normalize();
      this.scene.add(directionalLight1);


      // 环境光源
      const ambientLight = new window.THREE.AmbientLight(0x323296, 0.2);
      this.scene.add(ambientLight);
    },

    animate() {
      // 通过请求动画帧来实现循环
      requestAnimationFrame(this.animate);

      // 旋转地球
      this.earth.rotation.y += 0.005;

      // 旋转月亮
      this.moons.forEach(moon => moon.rotation.y += 0.005);

      // 月亮围绕地球旋转
      this.moons.forEach((moon, index) => {
        const angle = (index * Math.PI / 2) + (this.earth.rotation.y * 1.5);
        moon.position.x = 10 * Math.cos(angle);
        moon.position.z = 10 * Math.sin(angle);
      });

      // 渲染场景
      this.renderer.render(this.scene, this.camera);
    },

    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
  }
};
</script>

<style scoped>
#paul {
  height: 100vh;
  width: 100vw;
  z-index: 5;
  position: fixed;
}

.three-container {
  margin-top: 5vw;
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
}
</style>
